import { ReactElement } from 'react';

import config from '../config/index.json';

interface IAppStoreButton {
    href: string;
    src: string;
    imgAlt: string;
}

const AppStoreButton = ({ href, src, imgAlt }: IAppStoreButton): ReactElement => {
    return (
        <div className={'scale-75 sm:scale-50 lg:scale-75'}>
            <a href={href}><img src={src} alt={imgAlt} /></a>
        </div>
    );
};

export const AppStoreButtons = (): ReactElement => {
    const { mainHero } = config;
    const { appStore1, appStore2 } = mainHero;

    return (
        <div className='mt-5 sm:mt-8 flex justify-center lg:justify-start'>
            <AppStoreButton href={appStore1.href} src={appStore1.src} imgAlt={'Google Play'} />
            <AppStoreButton href={appStore2.href} src={appStore2.src} imgAlt={'Apple Store'} />
        </div>
    );
};
